import "./index.css";
import Button from "../button";
import { useState } from "react";
import { createCustomPostFromText } from "../../functions/createCustomPostFromText";
import { createCustomPostFromURL } from "../../functions/createCustomPostFromURL";

function CustomPostModule({ display, functionForButton }) {
  const [stageNumber, SetStageNumber] = useState(0);
  const [isError, SetIsError] = useState(false);
  const [errorMessage, SetErrorMessage] = useState("");
  const [inputType, setInputType] = useState(""); // 'url' or 'scratch'
  const [url, setUrl] = useState("");
  const [customText, setCustomText] = useState("");

  const goToSites = () => {
    window.location.href = "/sites";
  };

  const handleClick = async (postType) => {
        SetIsError(false);
    SetErrorMessage("");
    if (inputType === "url") {
      let response = await createCustomPostFromURL(SetIsError, SetErrorMessage, url,postType);
    } else if (inputType === "scratch") {
      console.log("Submitted custom post:", customText); // Replace with real logic
      let response = await createCustomPostFromText(SetIsError, SetErrorMessage, customText);
      SetStageNumber(stageNumber + 1);
    }
  };

  const [stages] = useState([
    {
      title: "Create a post",
      body:
        "Don't want to wait for your feed to populate to create a post? Create a custom post right now!",
      displayOfInputBar: true,
    }
  ]);

  const handleClose = () => {
    setInputType("");
    functionForButton();
    SetIsError(false);
    SetErrorMessage("");
  }

  const handleBack = () => {
    setInputType("");
    SetIsError(false);
    SetErrorMessage("");
  };

  return (
    <div id="blur-wrapper" style={{ display: display }}>
      <div id="custom-post-module">
        <div className="input-module-title-holder">
          <h2 className="big-text">{stages[stageNumber].title}</h2>
          <img alt="close" src="./images/close.png" onClick={handleClose} />
        </div>

        <div className="small-text">{stages[stageNumber].body}</div>

        {stages[stageNumber].displayOfInputBar && (
          <>
            {!inputType && (
              <div className="button-holder" id="which-custom">
                <Button text="Scan a URL" addedFunction={() => setInputType("url")} />
                <Button text="Write post" addedFunction={() => setInputType("scratch")} />
              </div>
            )}

            {inputType === "url" && (
              <>
                <input
                  id="url-input-field"
                  type="text"
                  placeholder="Enter URL..."
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}
                />
                    <div
                            id="input-error-module"
                            style={{ display: isError ? "block" : "none" }}
                            dangerouslySetInnerHTML={{ __html: errorMessage }}
                          ></div>
                <div className="button-holder">
                  <Button text="Back" addedFunction={handleBack} />
                  <Button text="Create blog" addedFunction={handleClick}  params="blog"/>
                  <Button text="Create LinkedIn post" addedFunction={handleClick} params="post" />
                </div>
              </>
            )}

            {inputType === "scratch" && (
              <>
                <textarea
                  id="text-input-field"
                  placeholder="Write your post here..."
                  value={customText}
                  onChange={(e) => setCustomText(e.target.value)}
                  rows={5}
                />
                        <div
                            id="input-error-module"
                            style={{ display: isError ? "block" : "none" }}
                            dangerouslySetInnerHTML={{ __html: errorMessage }}
                          ></div>
                <div className="button-holder">
                  <Button text="Back" addedFunction={handleBack} />
                  <Button text="Submit post" addedFunction={handleClick} />
                </div>
              </>
            )}
          </>
        )}

        {stageNumber === 1 && (
          <div className="button-holder">
            <Button text="Show my sites" addedFunction={goToSites} />
          </div>
        )}
      </div>
    </div>
  );
}

export default CustomPostModule;
